import React from 'react'
import { Box, Typography } from '@mui/material'
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded'
import { ExternalGigproLinks } from '../../constants'
import { useForwardedHref } from '../../utils/appUrl'
import { MonoButton } from './components'

const buildPhoneLoginUrl = (phoneE164: string): string => {
  const base = ExternalGigproLinks.login.replace(/\/$/, '')
  return `${base}/auth/phone?phone=${encodeURIComponent(phoneE164)}`
}

type Props = {
  phoneE164: string
  onBack: () => void
}

export const CheckoutConflict: React.FC<Props> = ({ phoneE164, onBack }) => {
  const href = useForwardedHref(buildPhoneLoginUrl(phoneE164))
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        gap: 1.5,
        p: '48px 40px',
        minHeight: 380,
        justifyContent: 'center',
      }}
    >
      <AccountCircleRoundedIcon
        sx={{ fontSize: 64, color: 'primary.main', mb: 0.5 }}
      />
      <Typography
        variant="h3"
        component="h2"
        sx={{ fontSize: 22, fontWeight: 900, textTransform: 'uppercase' }}
      >
        You already have an account
      </Typography>
      <Typography
        sx={{
          fontSize: 14,
          color: 'neutral.gray',
          lineHeight: 1.7,
          maxWidth: 420,
        }}
      >
        An account with this phone number already exists. Log in to post your
        shift.
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: 1.5,
          mt: 2,
        }}
      >
        <MonoButton
          type="button"
          variant="text"
          onClick={onBack}
          sx={{ fontSize: 11, color: 'neutral.gray' }}
        >
          ← Go back
        </MonoButton>
        <MonoButton
          variant="contained"
          color="primary"
          href={href}
          sx={{ px: 3, fontWeight: 700 }}
        >
          Log in →
        </MonoButton>
      </Box>
    </Box>
  )
}
